import React, { useRef } from "react";
import { ChevronDownIcon, ChartBarIcon, CalendarIcon, FunnelIcon, PrinterIcon, DocumentChartBarIcon, UsersIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { ToastContainer, toast } from 'react-toastify';

import axios from 'axios';
import { getTokenCredentials } from "../../Shared/functions";
import { BASE_API } from "../../Shared/Constants";
import { getRanges } from "../officials/services/officials";
import ResponsiveTable from "../../Shared/ResponsiveTable";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
  } from 'chart.js';
import { Bar, Pie, Doughnut} from 'react-chartjs-2';
import html2canvas from 'html2canvas';
import Breadcrumb from "../../Shared/BreadCumb";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

export default class Metrics extends React.Component {


    BreadcrumbPages = [
        { name: 'Administración', href: '#', current: false },
        { name: 'Métricas', href: '#', current: true },
    ]

    TYPE_REVOCATION = [
        {id:0, name:'Seleccione un tipo de revocación...'},
        {id:1, name:'DUPLICIDAD'},
        {id:2, name:'ERROR EN LA APLICACIÓN.'},
        {id:3, name:'NULIDAD'},
        {id:4, name:'OTRAS'},
    ]

    columnsOficcial = [
        {field:'firstName', headerName: 'Nombre'},
        {field:'firstLastName', headerName: 'Apellido'},
        {field:'identification', headerName: 'identificación'},
        {field:'total', headerName: 'Total de multas generadas'},
        {field:'percentage', headerName: '%'}
    ]


    REPORT_TYPE = {
        SECTOR: 1,
        STATUS: 2,
        OFFICIAL: 3,
        DETAIL_DAY: 4,
        PENALITY: 5,
        HOUR: 6,
        DEFAULTER: 7,
        PAID_SECTOR: 8,
        VEHICLE: 9,
        REVOCATION: 10,
        OFFICIAL_MONTH: 11,
    };

    constructor(props){
        super(props);
        this.state = {
            type: 0,
            start: new Date(),
            end: new Date(),
            limit:100,
            sector: [],
            sectorId: 0,
            penalitiesStatus: [],
            penalitieStatusId:0,
            idRange:0,
            identification:'',
            userName:'',
            code:'',
            oficcialResult: [],
            idStatus:-1,
            concepts: [],
            conceptId: 0,
            idTypeRevocation: 0,
            showChart: false,
            showVehicle: false,
            labels: [],
            items: [],
            loading: false,
            ranges:[],
            showTable: false,
            renderTotals:false,
            totalMessage: '',
            typeBar:0,
            imaeg:'',
            totalM:'',
            totalC:'',
            totalV:'',

            resultByhour: [],
            showByHourTable: false,
            isHour:false,
        }
        this.captureRef = React.createRef();
        this.chartRef = React.createRef();
    }

    componentDidMount(){
        axios.post(BASE_API + 'api/sync/syncapk', {id:0}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic '+getTokenCredentials()
            }
        }).then((result) => {
            getRanges({id: 0,idAdminDescrip: 4,active: true,limit:500}).then((result) => {
                this.setState({
                    ranges: result.data.data
                });
            })
            this.setState({
                sector:result.data.data[0].sector,
                concepts: result.data.data[0].concept
            });
        }).catch((err) => {
            console.log(err);
        });
    }

    startSearch(download = false){
        
        let url = '';
        let body = {limit:this.state.limit};
        if(this.state.type === 0 && !download) {
            return toast('Por favor selecciona un tipo de consulta');
        }
        if(this.state.typeBar === 0 && this.state.type !== 3 && this.state.type !== 9 && this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 10 && this.state.type !== 11 && !download) {
            return toast('Por favor seleccionar un tipo de grafico');
        }
        this.setState({loading:true});
        if(this.state.type === 1) {
            url = 'api/statistics/bysector';
            body.idSector = this.state.sectorId;
        }
        if(this.state.type === 2) {
            url = 'api/metrics/bystatus';
            body.idStatus = this.state.idStatus;
        }
        if(this.state.type === 3) {
            url = 'api/statistics/byofficial';
            if(this.state.idRange > 0) {
                body.idRange = this.state.idRange;
            }
            if(this.state.identification !== '') {
                body.identification = this.state.identification;
            }
            if(this.state.userName !== '') {
                body.userName = this.state.userName;
            }
            if(this.state.code !== '') {
                body.code = this.state.code;
            }
        }

        if(this.state.type === 4) {
            url = 'api/statistics/bydetailday';
        }   

        if(this.state.type === 5) {
            url = 'api/statistics/byinfringement';
            body.idConcept = this.state.conceptId;
        }

        if(this.state.type === 6){
            url = 'api/statistics/byhour';

        }

        if(this.state.type === 7) {
            url = 'api/statistics/bydefaulter';
        }
        
        if(this.state.type === 8) {
            url = 'api/statistics/bypaidsector';
            body.idSector = this.state.sectorId;
        }

        if(this.state.type === 9) {
            url = 'api/statistics/byvehicle';
        }

        if(this.state.type === 10) {
            url = 'api/statistics/byrevocation';
            body.idTypeRevocation = this.state.idTypeRevocation;
        }

        if(this.state.type === 11) {
            url = 'api/statistics/byofficialxmonth';
        }

        body.limit = parseInt(this.state.limit);
        if(this.state.start) {
            body.dateStart = this.state.start + 'T00:00:00Z';
        }
        if(this.state.end) {
            body.dateEnd = this.state.end + 'T23:00:00Z';
        }

        if(download) {
            body.isReport = true;
        }

        axios.post(BASE_API + url, body , {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic '+getTokenCredentials()
            }
        })
        .then(response => {
            console.log(response)
            this.setState({loading:false});
            if(response && response.data.data && !download) {
                if(this.state.type === this.REPORT_TYPE.SECTOR) {
                    this.organiceDataTypeSector(response.data.data);
                }
                if(this.state.type === this.REPORT_TYPE.STATUS) {
                    this.organiceDataByStatus(response.data.data);
                }
                if(this.state.type === this.REPORT_TYPE.OFFICIAL) {
                    this.setState({showTable:true, showChart:false, oficcialResult:response.data.data, 
                        renderTotals:true, totalMessage: response.data.data[0].totalGeneral,
                        totalM: response.data.data[0].totalM,
                        totalC: response.data.data[0].totalCM,
                    })
                }
                if(this.state.type === this.REPORT_TYPE.PENALITY){
                    this.organiceDataByPenalitie(response.data.data);
                }
    
                if(this.state.type === this.REPORT_TYPE.DETAIL_DAY) {
                    const data = response.data.data;
                    this.setState({
                        isHour:false,
                        resultByhour: data,
                        showByHourTable: true,
                        renderTotals:true, totalMessage: data[0].totalGeneral,
                        totalM: data[0].totalM,
                        totalC: data[0].totalCM,
                        totalV: data[0].totalVehicle,
                    })
                }

                if(this.state.type === this.REPORT_TYPE.HOUR) {
                    const data = response.data.data.map((item) => {
                        item.hourTime = this.convertirHora24a12(item.hour);
                        return item;
                    });
                    this.setState({
                        isHour:true,
                        resultByhour: data,
                        showByHourTable: true,
                        showChart: true,
                        renderTotals:true, totalMessage: data[0].totalGeneral,
                        totalM: data[0].totalM,
                        totalC: data[0].totalCM,
                        totalV: data[0].totalVehicle,
                    })
                }

                if(this.state.type === this.REPORT_TYPE.DEFAULTER) {
                    this.organiceDataDefauler(response.data.data);
                }
                if(this.state.type === this.REPORT_TYPE.PAID_SECTOR){
                    this.organiceDataTypeSector(response.data.data);
                }
                if(this.state.type === this.REPORT_TYPE.VEHICLE) {
                    this.organiceDataVehicle(response.data.data)
                }
                if(this.state.type === this.REPORT_TYPE.REVOCATION) {
                    this.organiceDataRevocation(response.data.data);
                }
                if(this.state.type === this.REPORT_TYPE.OFFICIAL_MONTH) {
                    this.setState({showTable:true, showChart:false, oficcialResult:response.data.data, renderTotals:false})
                }
            }else if(download) {
                window.open(response.data.data.url);
                toast('Reporte descargado correctamente');
            }else{
                toast('no hay registros que mostrar');
            }

            
        })
        .catch(error => {
            this.setState({loading:false});
            toast(error.response.data.message);
        });

    }

    convertirHora24a12(hora24) {
        if (typeof hora24 !== 'number' || hora24 < 0 || hora24 > 24) {
            return null;
        }

        if (hora24 === 0) {
            return "12 AM";
        } else if (hora24 < 12) {
            return `${hora24} AM`;
        } else if (hora24 === 12) {
            return "12 PM";
        } else if (hora24 < 24) {
            return `${hora24 - 12} PM`;
        } else {
            return "12 AM";
        }
    }

    organiceDataDefauler(data){
        const labels = data.map((item) => item.status);
        const items = data.map((item) => item.percentage);
        this.setState({showChart: true, showTable:false, labels:labels, items:items,
            renderTotals:true, totalMessage: data[0].totalGeneral,
            totalM: data[0].totalM,
            totalC: data[0].totalCM,
            showVehicle:false,
            totalV:'',
        });
    }

    organiceDataVehicle(data){
        const items = data.map((item) => item.percentage);
        this.setState({showChart: false, showTable:false, labels:[], items:items,
            renderTotals:true, totalMessage: data[0].totalGeneral,
            totalM: data[0].totalM,
            totalC: data[0].totalCM,
            totalV: data[0].totalVehicle,
            showChart:true,
            showVehicle:true
        });
    }

    organiceDataByStatus(data){
        const labels = data.map((item) => item.status + ' Total: ' + item.total);
        const items = data.map((item) => item.percentage);
        this.setState({showChart: true, showTable:false, labels:labels, items:items,
             renderTotals:true, totalMessage: data[0].totalGeneral ,
             totalM: data[0].totalM,
             totalC: data[0].totalCM,
             showVehicle:false,
             totalV:'',
        });
    }

    organiceDataTypeSector(data){
        const labels = data.map((item) => item.sector + ' Total: ' + item.total);
        const items = data.map((item) => item.percentage);
        this.setState({showChart: true, showTable:false, labels:labels, items:items, renderTotals:true, totalMessage: data[0].totalGeneral,
            totalM: data[0].totalM,
            totalC: data[0].totalCM,
            totalV:'',
            showVehicle:false,
        });
    }

    organiceDataByPenalitie(data){
        const labels = data.map((item) => item.concept);
        const items = data.map((item) => item.percentage);
        this.setState({showChart: true, showTable:false, labels:labels, items:items,
            renderTotals:true, totalMessage: data[0].totalGeneral,
            totalM: data[0].totalM,
            totalC: data[0].totalCM,
            showVehicle:false,
            totalV:'',
        });
    }

    organiceDataRevocation(data){
        const labels = data.map((item) => item.typeRevocation + ' Total: ' + item.total);
        const items = data.map((item) => item.total);
        this.setState({showChart: true, showTable:false, labels:labels, items:items
        });
    }

    renderPenalitiesStatus = () => {
        return(
            <div className="relative">
                <select
                    onChange={(e) => {this.setState({idStatus: parseInt(e.target.value)})}}
                    id="status"
                    className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                >
                    <option value={-1}>Todos los estados</option>
                    <option value={0}> Pendiente por Pagar</option>
                    {/*<option value={1}> En Pausa</option>*/}
                    <option value={2}> En Morosidad</option>
                    <option value={3}> Pagada</option>
                    <option value={4}> Llamado de Atención</option>
                    <option value={5}> Pago Parcial</option>
                    <option value={6}> Revocada</option>
                </select>
                <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            </div>
        )
    }

    renderSectorlist = () => {
        return(
            <div className="relative">
                <select
                    onChange={(e) => {this.setState({sectorId: parseInt(e.target.value)})}}
                    id="sector"
                    className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                >
                    <option value={0}>Todos los sectores</option>
                    {this.state.sector.map((item) => {
                        return (<option key={item.id} value={item.id}>{item.value}</option>)
                    })}
                </select>
                <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            </div>
        )
    }

    renderOficcialForm = () => {
        return(
            <div className="space-y-4">
                <div>
                    <label htmlFor="identification" className="block text-sm font-medium text-gray-700 mb-2">
                        Identificación
                    </label>
                    <input
                        value={this.state.identification}
                        onChange={(e) => {this.setState({identification:e.target.value})}}
                        id="identification"
                        type="text"
                        placeholder="Ej: 12345678"
                        className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="officialCode" className="block text-sm font-medium text-gray-700 mb-2">
                        Código de funcionario
                    </label>
                    <input
                        value={this.state.code}
                        onChange={(e) => {this.setState({code:e.target.value})}}
                        id="officialCode"
                        type="text"
                        placeholder="Ej: FUN001"
                        className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="userName" className="block text-sm font-medium text-gray-700 mb-2">
                        Nombre de usuario
                    </label>
                    <input
                        value={this.state.userName}
                        onChange={(e) => {this.setState({userName:e.target.value})}}
                        id="userName"
                        type="text"
                        placeholder="Ej: juan.perez"
                        className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                    />
                </div>
            </div>
        )
    }

    renderConceptForm = () => {
        return(
            <div className="relative">
                <select
                    onChange={(e) => {this.setState({conceptId: parseInt(e.target.value)})}}
                    id="concept"
                    className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                >
                    <option value={0}>Seleccionar concepto...</option>
                    {this.state.concepts.map((item) => {
                        return (<option key={item.id} value={item.id}>{item.concept}</option>)
                    })}
                </select>
                <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            </div>
        )
    }

    renderRevocationForm = () => {
        return(
            <div className="relative">
                <select
                    onChange={(e) => {this.setState({idTypeRevocation: parseInt(e.target.value)})}}
                    value={this.state.idTypeRevocation}
                    id="revocation"
                    className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                >
                    {this.TYPE_REVOCATION.map((item) => {
                        return (<option key={item.id} value={item.id}>{item.name}</option>)
                    })}
                </select>
                <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            </div>
        )
    }

    renderChart(){
        const options = {
            responsive: true,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Grafico',
              },
            } 
          }
          if(this.state.typeBar === 1) {
            options.indexAxis = 'y';
          }

          const labels = this.state.labels ? this.state.labels : ['%']
          const data = {
            labels,
            datasets: [{
                label: '%',
                data: this.state.items,
                backgroundColor: this.generateColors(this.state.items.length) 
            }],
          };
          if(this.state.typeBar === 3) {
            return (
                <div style={{maxHeight:700, display:'flex', flexDirection:'row', justifyContent:'center'}}>
                    <Pie data={data} updateMode="resize" />
                </div>
            )
          }else if(this.state.typeBar === 2 || this.state.typeBar === 1){
                return(
                    <div style={{maxHeight:700, display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Bar options={options} data={data} updateMode="resize"/>;
                    </div>
                )
          }else{
            return (
                <div style={{maxHeight:500, display:'flex', flexDirection:'row', justifyContent:'center'}}>
                     <Doughnut data={data} updateMode="resize"/>
                </div>
            )
          }
    }
    generateColors(count) {
        const colors = [];
        for (let i = 0; i < count; i++) {
          const r = Math.floor(Math.random() * 100) + 100;
          const g = Math.floor(Math.random() * 100) + 100;
          const b = Math.floor(Math.random() * 100) + 100;
          colors.push(`rgb(${r}, ${g}, ${b})`);
        }
        return colors;
      }

    renderOficialTable(){
        return <ResponsiveTable columns={this.columnsOficcial} data={this.state.oficcialResult}/>
    }

    renderTotals(){
        return(
            <div className="mb-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-gradient-to-br from-blue-950 to-blue-900 rounded-2xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-200">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-blue-100 text-sm font-medium mb-1">Total General</p>
                            <p className="text-3xl font-bold">{this.state.totalMessage?.toLocaleString() || '0'}</p>
                        </div>
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3">
                            <DocumentChartBarIcon className="h-8 w-8 text-blue-100" />
                        </div>
                    </div>
                    <div className="mt-4 flex items-center">
                        <div className="w-full bg-blue-800 rounded-full h-2">
                            <div className="bg-blue-300 h-2 rounded-full" style={{width: '100%'}}></div>
                        </div>
                    </div>
                </div>
                
                <div className="bg-gradient-to-br from-green-700 to-green-600 rounded-2xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-200">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-green-100 text-sm font-medium mb-1">Multas Generadas</p>
                            <p className="text-3xl font-bold">{this.state.totalM?.toLocaleString() || '0'}</p>
                        </div>
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3">
                            <ChartBarIcon className="h-8 w-8 text-green-100" />
                        </div>
                    </div>
                    <div className="mt-4 flex items-center">
                        <div className="w-full bg-green-600 rounded-full h-2">
                            <div className="bg-green-300 h-2 rounded-full" style={{width: '85%'}}></div>
                        </div>
                    </div>
                </div>
                
                <div className="bg-gradient-to-br from-orange-600 to-orange-500 rounded-2xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-200">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-orange-100 text-sm font-medium mb-1">Calco Multas</p>
                            <p className="text-3xl font-bold">{this.state.totalC?.toLocaleString() || '0'}</p>
                        </div>
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3">
                            <DocumentChartBarIcon className="h-8 w-8 text-orange-100" />
                        </div>
                    </div>
                    <div className="mt-4 flex items-center">
                        <div className="w-full bg-orange-500 rounded-full h-2">
                            <div className="bg-orange-300 h-2 rounded-full" style={{width: '70%'}}></div>
                        </div>
                    </div>
                </div>
                
                {this.state.totalV && (
                    <div className="bg-gradient-to-br from-purple-600 to-purple-500 rounded-2xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-200">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-purple-100 text-sm font-medium mb-1">Total Vehículos</p>
                                <p className="text-3xl font-bold">{this.state.totalV?.toLocaleString() || '0'}</p>
                            </div>
                            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3">
                                <ChartBarIcon className="h-8 w-8 text-purple-100" />
                            </div>
                        </div>
                        <div className="mt-4 flex items-center">
                            <div className="w-full bg-purple-500 rounded-full h-2">
                                <div className="bg-purple-300 h-2 rounded-full" style={{width: '60%'}}></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    renderVehicle(){
        return(
            <></>
        )
    }

    checkPermissions = () => {
      const issues = [];
      
      try {
        const testWindow = window.open('', '_blank');
        if (!testWindow || testWindow.closed || typeof testWindow.closed === 'undefined') {
          issues.push('popup');
        } else {
          testWindow.close();
        }
      } catch (e) {
        issues.push('popup');
      }

      const metaCSP = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
      if (metaCSP) {
        const csp = metaCSP.getAttribute('content') || '';
        if (csp.includes("script-src 'self'") && !csp.includes('unsafe-inline')) {
          issues.push('csp');
        }
      }

      return issues;
    };

    handleCaptureAndDownload = () => {
        if (!this.chartRef.current) {
          toast.error('No se puede capturar el gráfico. Por favor, genere el gráfico primero.');
          return;
        }

        toast.info('Generando imagen para descarga, por favor espere...', { autoClose: 2000 });

        const options = {
          allowTaint: true,
          useCORS: true,
          scale: 1,
          logging: false,
          backgroundColor: '#ffffff',
          removeContainer: true,
          imageTimeout: 15000,
          foreignObjectRendering: false,
          onclone: (clonedDoc) => {
            try {
              const images = clonedDoc.querySelectorAll('img');
              images.forEach((img) => {
                if (img.complete && img.naturalHeight !== 0) {
                  return;
                }
                img.crossOrigin = 'anonymous';
              });

              const canvases = clonedDoc.querySelectorAll('canvas');
              canvases.forEach((canvas) => {
                try {
                  canvas.getContext('2d');
                } catch (e) {
                  console.warn('No se pudo obtener contexto del canvas:', e);
                }
              });
            } catch (error) {
              console.warn('Error en onclone:', error);
            }
          }
        };

        html2canvas(this.chartRef.current, options)
          .then(canvas => {
            try {
              const imgData = canvas.toDataURL('image/png', 1.0);
              if (!imgData || imgData === 'data:,') {
                throw new Error('Error al generar la imagen');
              }
              this.setState({ image: imgData });
              this.downloadImage(imgData);
            } catch (error) {
              console.error('Error al procesar la imagen:', error);
              toast.error('Error al procesar la imagen. Por favor, intente nuevamente.');
            }
          })
          .catch(error => {
            console.error('Error al capturar el gráfico:', error);
            let errorMessage = 'Error al capturar el gráfico. ';
            
            if (error.message && error.message.includes('CORS')) {
              errorMessage += 'Problema con permisos CORS. Contacte al administrador.';
            } else if (error.message && error.message.includes('timeout')) {
              errorMessage += 'Tiempo de espera agotado. Intente nuevamente.';
            } else {
              errorMessage += 'Por favor, intente nuevamente.';
            }
            
            toast.error(errorMessage, { autoClose: 6000 });
          });
      };

    handleCapture = () => {
        if (!this.chartRef.current) {
          toast.error('No se puede capturar el gráfico. Por favor, genere el gráfico primero.');
          return;
        }

        const permissionIssues = this.checkPermissions();
        if (permissionIssues.includes('popup')) {
          toast.warning('Las ventanas emergentes están bloqueadas. Se descargará la imagen automáticamente.', {
            autoClose: 5000
          });
        }

        toast.info('Generando imagen, por favor espere...', { autoClose: 2000 });

        const options = {
          allowTaint: true,
          useCORS: true,
          scale: 1,
          logging: false,
          backgroundColor: '#ffffff',
          removeContainer: true,
          imageTimeout: 15000,
          foreignObjectRendering: false,
          onclone: (clonedDoc) => {
            try {
              const images = clonedDoc.querySelectorAll('img');
              images.forEach((img) => {
                if (img.complete && img.naturalHeight !== 0) {
                  return;
                }
                img.crossOrigin = 'anonymous';
              });

              const canvases = clonedDoc.querySelectorAll('canvas');
              canvases.forEach((canvas) => {
                try {
                  canvas.getContext('2d');
                } catch (e) {
                  console.warn('No se pudo obtener contexto del canvas:', e);
                }
              });
            } catch (error) {
              console.warn('Error en onclone:', error);
            }
          }
        };

        html2canvas(this.chartRef.current, options)
          .then(canvas => {
            try {
              const imgData = canvas.toDataURL('image/png', 1.0);
              if (!imgData || imgData === 'data:,') {
                throw new Error('Error al generar la imagen');
              }
              this.setState({ image: imgData });
              
              if (permissionIssues.includes('popup')) {
                this.downloadImage(imgData);
              } else {
                this.handlePrintImage(imgData);
              }
            } catch (error) {
              console.error('Error al procesar la imagen:', error);
              toast.error('Error al procesar la imagen. Por favor, intente nuevamente.');
            }
          })
          .catch(error => {
            console.error('Error al capturar el gráfico:', error);
            let errorMessage = 'Error al capturar el gráfico. ';
            
            if (error.message && error.message.includes('CORS')) {
              errorMessage += 'Problema con permisos CORS. Contacte al administrador.';
            } else if (error.message && error.message.includes('timeout')) {
              errorMessage += 'Tiempo de espera agotado. Intente nuevamente.';
            } else {
              errorMessage += 'Por favor, intente nuevamente.';
            }
            
            toast.error(errorMessage, { autoClose: 6000 });
          });
      };

      handlePrintImage = (image) => {
        try {
          if (!image || image === 'data:,') {
            toast.error('La imagen generada no es válida');
            return;
          }

          let newWindow;
          try {
            newWindow = window.open('', '_blank', 'width=800,height=600');
          } catch (e) {
            console.warn('Error al abrir ventana:', e);
            newWindow = null;
          }
          
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            toast.warning('La ventana emergente fue bloqueada por el navegador. Descargando imagen automáticamente...', {
              autoClose: 5000
            });
            this.downloadImage(image);
            return;
          }

          setTimeout(() => {
            try {
              if (newWindow.closed) {
                toast.warning('La ventana fue cerrada. Descargando imagen...');
                this.downloadImage(image);
                return;
              }

              newWindow.document.open();
              newWindow.document.write(`
                <!DOCTYPE html>
                <html>
                  <head>
                    <meta charset="utf-8">
                    <title>Impresión de Métricas</title>
                    <style>
                      @media print {
                        @page { margin: 0; }
                        body { margin: 0; padding: 0; }
                        img { 
                          width: 100%; 
                          height: auto; 
                          page-break-inside: avoid;
                          display: block;
                        }
                      }
                      @media screen {
                        body { 
                          margin: 20px; 
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          min-height: 100vh;
                        }
                        img { 
                          max-width: 100%; 
                          height: auto;
                          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                        }
                      }
                    </style>
                  </head>
                  <body>
                    <img src="${image}" alt="Captura de métricas" 
                         onload="setTimeout(function() { 
                           try { 
                             window.print(); 
                           } catch(e) { 
                             console.error('Error al imprimir:', e);
                             alert('Error al imprimir. Puede descargar la imagen haciendo clic derecho sobre ella.');
                           }
                         }, 500);" 
                         onerror="alert('Error al cargar la imagen. Por favor, intente nuevamente.'); window.close();" />
                    <script>
                      window.onafterprint = function() { 
                        setTimeout(function() { window.close(); }, 100);
                      };
                    </script>
                  </body>
                </html>
              `);
              newWindow.document.close();
              
              setTimeout(() => {
                if (newWindow && !newWindow.closed) {
                }
              }, 2000);
              
            } catch (error) {
              console.error('Error al escribir en la ventana:', error);
              if (newWindow && !newWindow.closed) {
                newWindow.close();
              }
              toast.error('Error al abrir la ventana de impresión. Descargando imagen...');
              this.downloadImage(image);
            }
          }, 100);
        } catch (error) {
          console.error('Error en handlePrintImage:', error);
          toast.error('Error al procesar la impresión. Descargando imagen...');
          this.downloadImage(image);
        }
      };

      downloadImage = (image) => {
        try {
          if (!image || image === 'data:,') {
            toast.error('La imagen generada no es válida para descargar');
            return;
          }

          const byteString = atob(image.split(',')[1]);
          const mimeString = image.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.download = `metricas_${new Date().toISOString().slice(0, 10)}_${new Date().getTime()}.png`;
          link.href = blobUrl;
          link.style.display = 'none';
          
          document.body.appendChild(link);
          
          try {
            link.click();
            toast.success('Imagen descargada correctamente');
          } catch (error) {
            console.warn('Error al hacer clic en el enlace:', error);
            window.open(blobUrl, '_blank');
            toast.info('Abriendo imagen en nueva pestaña. Puede descargarla desde allí.');
          }
          
          setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          }, 100);
          
        } catch (error) {
          console.error('Error al descargar la imagen:', error);
          
          try {
            const link = document.createElement('a');
            link.download = `metricas_${new Date().getTime()}.png`;
            link.href = image;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success('Imagen descargada correctamente');
          } catch (fallbackError) {
            console.error('Error en fallback de descarga:', fallbackError);
            toast.error('Error al descargar la imagen. Por favor, contacte al administrador si el problema persiste.');
          }
        }
      };

    updateType(type){
        this.setState({
            type: type,
            start:'',
            end:'',
            limit:0,
            sectorId: 0,
            penalitieStatusId:0,
            idRange:0,
            identification:'',
            userName:'',
            code:'',
            idStatus:-1,
            conceptId: 0,
            idTypeRevocation: 0,
            showChart: false,
            loading: false,
            showTable: false,
            renderTotals:false,
            totalMessage: '',
            totalM: '',
            totalC:'',
            typeBar:0,
            imaeg:'',
            totalM:'',
            totalC:'',
            totalV:'',

            resultByhour: [],
            showByHourTable: false,
        })
    }

    renderTable(){
        let colums;
        if(this.state.isHour) {
             colums = [
                {field:'hourTime', headerName: 'Hora'},
                {field:'percentage', headerName: 'Porcentaje %'},
                {field:'total', headerName: 'Total'},
            ] 
        }else{
             colums = [
                {field:'date', headerName: 'Fecha'},
                {field:'percentage', headerName: 'Porcentaje %'},
                {field:'total', headerName: 'Total'},
            ] 
        }
        return  <ResponsiveTable columns={colums} data={this.state.resultByhour}/>

    }

    render(){
        return(
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Breadcrumb pages={this.BreadcrumbPages}/>
                
                <div className="py-8">
                    <div className="mb-8">
                        <div className="bg-gradient-to-r from-blue-950 to-blue-900 rounded-2xl p-8 text-white shadow-xl">
                            <div className="flex items-center justify-between">
                                <div>
                                    <div className="flex items-center mb-2">
                                        <ChartBarIcon className="h-8 w-8 text-blue-300 mr-3" />
                                        <h1 className="text-3xl font-bold">Panel de Métricas</h1>
                                    </div>
                                    <p className="text-blue-100 text-lg">
                                        Visualiza estadísticas y reportes detallados del sistema de multas
                                    </p>
                                </div>
                                <div className="hidden lg:block">
                                    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                                        <DocumentChartBarIcon className="h-12 w-12 text-blue-200" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8">
                        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 overflow-hidden">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-blue-950 rounded-full flex items-center justify-center">
                                            <ChartBarIcon className="h-6 w-6 text-white" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h3 className="text-lg font-bold text-gray-900">Configuración de Consulta</h3>
                                        <p className="text-sm text-gray-600">Selecciona el tipo de análisis a realizar</p>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="space-y-4">
                                    <div>
                                        <label htmlFor="queryType" className="block text-sm font-medium text-gray-700 mb-2">
                                            Seleccionar consulta
                                    </label>
                                    <div className="relative">
                                        <select
                                            onChange={(e) => {
                                                this.updateType(parseInt(e.target.value));
                                            }}
                                            id="queryType"
                                            className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        >
                                            <option value={0}>Seleccionar tipo...</option>
                                            <option value={1}> Totales por Sector</option>
                                            <option value={2}> Totales por Estatus</option>
                                            <option value={3}> Totales por Funcionarios</option>
                                            <option value={4}> Totales por Mes</option>
                                            <option value={5}> Totales por Infracciones</option>
                                            <option value={6}> Totales por Horas</option>
                                            <option value={7}> Totales Morosos</option>
                                            <option value={8}> Recaudadas por Sector</option>
                                            <option value={9}>Totales por Vehículos</option>
                                            <option value={10}>Por Revocación</option>
                                            <option value={11}>Total por Funcionario por Mes</option>
                                        </select>
                                        <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
                                    </div>
                                </div>

                                {this.state.type !== 3 && this.state.type !== 9 && this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 10 && this.state.type !== 11 && this.state.type !== 0 && (
                                    <div>
                                        <label htmlFor="chartType" className="block text-sm font-medium text-gray-700 mb-2">
                                            Tipo de gráfico
                                        </label>
                                        <div className="relative">
                                            <select
                                                value={this.state.typeBar}
                                                onChange={(e) => {this.setState({typeBar: parseInt(e.target.value), showChart:false, showTable:false})}}
                                                id="chartType"
                                                className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                            >
                                                <option value={0}>Seleccionar gráfico...</option>
                                                <option value={1}>Barra Horizontal</option>
                                                <option value={2}>Barra Vertical</option>
                                                <option value={3}>Gráfico de Torta</option>
                                                <option value={4}>Gráfico de Dona</option>
                                            </select>
                                            <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
                                        </div>
                                    </div>
                                )}

                                {this.state.type === 1 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Sector</label>
                                        {this.renderSectorlist()}
                                    </div>
                                )}
                                {this.state.type === 2 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
                                        {this.renderPenalitiesStatus()}
                                    </div>
                                )}
                                {this.state.type === 3 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Datos del funcionario</label>
                                        {this.renderOficcialForm()}
                                    </div>
                                )}
                                {this.state.type === 5 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Concepto</label>
                                        {this.renderConceptForm()}
                                    </div>
                                )}
                                {this.state.type === 8 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Sector</label>
                                        {this.renderSectorlist()}
                                    </div>
                                )}
                                {this.state.type === 10 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Revocación</label>
                                        {this.renderRevocationForm()}
                                    </div>
                                )}
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 overflow-hidden">
                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 border-b border-gray-200">
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-green-700 rounded-full flex items-center justify-center">
                                            <FunnelIcon className="h-6 w-6 text-white" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h3 className="text-lg font-bold text-gray-900">Filtros de Búsqueda</h3>
                                        <p className="text-sm text-gray-600">Configura los parámetros de consulta</p>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="space-y-4">
                                <div>
                                    {
                                        this.state.type !== this.REPORT_TYPE.OFFICIAL && this.state.type !== this.REPORT_TYPE.VEHICLE && (
                                            <div  className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label htmlFor="dateStart" className="block text-sm font-medium text-gray-700 mb-2">
                                                        <CalendarIcon className="inline h-4 w-4 mr-1" />
                                                        Fecha Desde
                                                    </label>
                                                    <input
                                                        value={this.state.start}
                                                        onChange={(e) => {this.setState({start:e.target.value})}}
                                                        id="dateStart"
                                                        type="date"
                                                        className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="dateEnd" className="block text-sm font-medium text-gray-700 mb-2">
                                                        <CalendarIcon className="inline h-4 w-4 mr-1" />
                                                        Fecha Hasta
                                                    </label>
                                                    <input
                                                        value={this.state.end}
                                                        onChange={(e) => {this.setState({end:e.target.value})}}
                                                        id="dateEnd"
                                                        type="date"
                                                        className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                    
                                </div>

                                {this.state.type !== 0 && this.state.type !== 1 && this.state.type !== 2 && this.state.type !== 8 && this.state.type !== 7 && this.state.type !== 9 && this.state.type !== 10 && (
                                    <div>
                                        <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                            Límite de registros
                                        </label>
                                        <div className="relative">
                                            <select
                                                value={this.state.limit}
                                                onChange={(e) => {this.setState({limit:e.target.value})}}
                                                id="limit"
                                                className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                            >
                                                <option value={0}>Todos los registros</option>
                                                <option value={10}>10 registros</option>
                                                <option value={50}>50 registros</option>
                                                <option value={100}>100 registros</option>
                                                <option value={500}>500 registros</option>
                                                <option value={1000}>1000 registros</option>
                                            </select>
                                            <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
                                        </div>
                                    </div>
                                )}

                                <div className="pt-6 border-t border-gray-200">
                                    <button
                                        onClick={() => this.startSearch(false)}
                                        type="button"
                                        className="w-full inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-blue-950 to-blue-900 rounded-xl shadow-lg hover:from-blue-900 hover:to-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950 transform hover:scale-105 transition-all duration-200"
                                    >
                                        <ChartBarIcon className="h-5 w-5 mr-2" />
                                        Generar Métricas
                                    </button>
                                    <br></br>
                                    <br></br>
                                    {
                                        (this.REPORT_TYPE.HOUR !== this.state.type 
                                            && this.REPORT_TYPE.VEHICLE !== this.state.type) && (   
                                            <button
                                                onClick={() => this.startSearch(true)}
                                                type="button"
                                                className="w-full inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-green-950 to-green-900 rounded-xl shadow-lg hover:from-green-900 hover:to-green-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-950 transform hover:scale-105 transition-all duration-200"
                                            >
                                                <ChartBarIcon className="h-5 w-5 mr-2" />
                                                Descargar Reporte
                                            </button>
                                        )
                                    }
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.loading && (
                        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-12 text-center mb-8">
                            <div className="flex flex-col items-center">
                                <div className="relative">
                                    <div className="w-16 h-16 bg-blue-950 rounded-full flex items-center justify-center mb-4">
                                        <ChartBarIcon className="h-8 w-8 text-white animate-pulse" />
                                    </div>
                                    <div className="absolute -top-1 -left-1 w-18 h-18 border-4 border-blue-200 border-t-blue-950 rounded-full animate-spin"></div>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">Generando Métricas</h3>
                                <p className="text-gray-600">Procesando datos y creando visualizaciones...</p>
                            </div>
                        </div>
                    )}

                    <div ref={this.captureRef}>
                        {this.state.renderTotals && this.renderTotals()}
                        
                        {this.state.showChart && this.state.type !== 6 && (
                            <div className="mb-8 bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <div className="w-8 h-8 bg-blue-950 rounded-full flex items-center justify-center mr-3">
                                                <ChartBarIcon className="h-5 w-5 text-white" />
                                            </div>
                                            <div>
                                                <h3 className="text-lg font-bold text-gray-900">Visualización de Datos</h3>
                                                <p className="text-sm text-gray-600">Gráfico interactivo de resultados</p>
                                            </div>
                                        </div>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={this.handleCapture}
                                                className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-950 bg-white rounded-lg border border-blue-200 hover:bg-blue-50 transition-colors duration-200 shadow-sm"
                                                title="Exportar e imprimir"
                                            >
                                                <PrinterIcon className="h-4 w-4 mr-2" />
                                                Imprimir
                                            </button>
                                            <button
                                                onClick={this.handleCaptureAndDownload}
                                                className="inline-flex items-center px-4 py-2 text-sm font-medium text-green-700 bg-white rounded-lg border border-green-200 hover:bg-green-50 transition-colors duration-200 shadow-sm"
                                                title="Descargar imagen"
                                            >
                                                <ArrowDownTrayIcon className="h-4 w-4 mr-2" />
                                                Descargar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-6" ref={this.chartRef}>
                                    {this.renderChart()}
                                </div>
                            </div>
                        )}
                        
                        {this.state.showVehicle && this.renderVehicle()}
                        
                        {this.state.showByHourTable && (
                            <div className="mb-8 bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200">
                                    <div className="flex items-center">
                                        <div className="w-8 h-8 bg-purple-700 rounded-full flex items-center justify-center mr-3">
                                            <DocumentChartBarIcon className="h-5 w-5 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-bold text-gray-900">Tabla de Resultados</h3>
                                            <p className="text-sm text-gray-600">Datos detallados en formato tabular</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="overflow-x-auto">
                                    {this.renderTable()}
                                </div>
                            </div>
                        )}
                    </div>
                    
                    {this.state.showTable && (
                        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 overflow-hidden">
                            <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-6 py-4 border-b border-gray-200">
                                <div className="flex items-center">
                                    <div className="w-8 h-8 bg-orange-600 rounded-full flex items-center justify-center mr-3">
                                        <UsersIcon className="h-5 w-5 text-white" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-gray-900">Resultados por Funcionario</h3>
                                        <p className="text-sm text-gray-600">Desempeño individual de funcionarios</p>
                                    </div>
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                {this.renderOficialTable()}
                            </div>
                        </div>
                    )}
                </div>
                <ToastContainer position="top-center" hideProgressBar={true}/>  
            </div>
        )
    }
}